__turbopack_context__.v({
  "commitmentsLinksList": "MobileMenuBottomLinks-module__q7Fjdq__commitmentsLinksList",
});
